'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));

function easeOutCubic(currentIteration, startValue, changeInValue, totalIterations) {
  return changeInValue * (Math.pow(currentIteration / totalIterations - 1, 3) + 1) + startValue;
}

var FUNCTIONS = Object.freeze({
  easeOutCubic: easeOutCubic
});

function snap($el, to, scroll, _ref) {
  var _ref$delay = _ref.delay,
      delay = _ref$delay === undefined ? 10 : _ref$delay,
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 75 : _ref$duration,
      _ref$fn = _ref.fn,
      fn = _ref$fn === undefined ? 'easeOutCubic' : _ref$fn,
      _ref$step = _ref.step,
      step = _ref$step === undefined ? 5 : _ref$step;

  var currentTime = 0;
  var next = FUNCTIONS[fn] || easeOutCubic;
  var start = $el[scroll];
  var change = to - start;

  var animate = function animate() {
    currentTime += step;

    $el[scroll] = next(currentTime, start, change, duration);

    if (currentTime < duration) {
      requestAnimationFrame(animate);
    }
  };

  setTimeout(animate, delay);
}

function snapY($el, to) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  snap($el, to, 'scrollTop', options);
}

function snapX($el, to) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  snap($el, to, 'scrollLeft', options);
}

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var _jsxFileName = '/Users/buckleyn/Projects/panels/panels-ui-compat.js.tmp';
var Panel = function (_React$Component) {
  inherits(Panel, _React$Component);

  function Panel() {
    classCallCheck(this, Panel);
    return possibleConstructorReturn(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).apply(this, arguments));
  }

  createClass(Panel, [{
    key: 'render',
    value: function render() {
      var props = this.props;


      return React.createElement(
        'div',
        {
          'aria-labelledby': props['aria-labelledby'],
          role: props.role,
          ref: props._ref,
          style: _extends({
            height: '100%',
            overflowY: 'auto'
          }, props.style),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 8
          },
          __self: this
        },
        props.children
      );
    }
  }]);
  return Panel;
}(React.Component);

var wrap = function wrap(i) {
  return i;
};

exports.Panel = Panel;
exports.wrap = wrap;
exports.snapX = snapX;
exports.snapY = snapY;